import gql from "graphql-tag";

export const PROFILE_QUERY = gql`
  query Profile {
    profile {
      email
      name
      birthdate
      phone
      title
    }
  }
`;
